module.exports = __webpack_public_path__ + "img/error_visual.59451da3.gif";